import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import Challenges from '@/views/Challenges.vue';
// import Challenge from '@/views/Challenge.vue';
import Denmark from '@/views/Denmark.vue';
import Europe from '@/views/Europe.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/challenges',
    name: 'Challenges',
    component: Challenges
  },
  {
    path: '/challenges/:challengeId',
    name: 'Challenge',
    component: Challenges
  },
  {
    path: '/challenges/:challengeId/:caseId',
    name: 'Case',
    component: Challenges
  },
  {
    path: '/denmark',
    name: 'Explore Denmark',
    component: Denmark
  },
  {
    path: '/denmark/facts',
    name: 'Facts about Denmark',
    component: Denmark
  },
  {
    path: '/denmark/:challengeId',
    name: 'Challenge (Denmark)',
    component: Denmark
  },
  {
    path: '/denmark/:challengeId/:caseId',
    name: 'Case (Denmark)',
    component: Denmark
  },
  {
    path: '/europe',
    name: 'Explore Europe',
    component: Europe
  },
  {
    path: '/europe/:challengeId',
    name: 'Challenge (Europe)',
    component: Europe
  },
  {
    path: '/europe/:challengeId/:caseId',
    name: 'Case (Europe)',
    component: Europe
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
});

export default router;